export default __webpack_public_path__ + "static/media/Curtain.4ec3d182.svg";